// extracted by mini-css-extract-plugin
export default {"error":"styles_error__b+0ps","errorWrapper":"styles_errorWrapper__7K3AQ"};